import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  BorderColorProps,
  ColorProps,
  DisplayProps,
  FontSizeProps,
  JustifyContentProps,
  SpaceProps,
} from 'styled-system';
import {
  alignItems,
  borderColor,
  color,
  display,
  fontSize,
  justifyContent,
  space,
} from 'styled-system';

import type { TextDecorationProps } from '../../theme/system-utilities';
import { textDecoration } from '../../theme/system-utilities';
import { ButtonLink } from '../Button';

type BackButtonStyledProps = AlignItemsProps &
  BorderColorProps &
  ColorProps &
  DisplayProps &
  FontSizeProps &
  JustifyContentProps &
  SpaceProps &
  TextDecorationProps;

const UnstyledBackButton = styled(ButtonLink)<BackButtonStyledProps>`
  ${alignItems};
  ${borderColor};
  ${color};
  ${display};
  ${fontSize};
  ${justifyContent};
  ${space};
  ${textDecoration};
`;

const BackButton = (props: ComponentProps<typeof UnstyledBackButton>) => (
  <UnstyledBackButton
    kind="secondary"
    alignItems="center"
    borderColor="sys.neutral.border.hover"
    color="sys.neutral.border.strong"
    display="flex"
    fontSize="fs_16"
    justifyContent="center"
    textDecoration="none"
    {...props}
  />
);

export default BackButton;
